import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import BusinessEditProfile from '../../components/EditProfile/BusinessEditProfile';
import OfficerEditProfile from '../../components/EditProfile/OfficerEditProfile';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';
import AdminEditProfile from '../../components/EditProfile/AdminEditProfile';

const EditProfilePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        {role === "business" && <BusinessEditProfile />}
        {role === "officer" && <OfficerEditProfile />}
        {role === "admin" && <AdminEditProfile />}
      </main>
      <LoginFooter />
    </>
  )
}

export default EditProfilePage;